import _ from "lodash";
/** external */
import React, { useRef } from "react";
import PropTypes from "prop-types";
/** internal */
import { useI18n } from "Hooks";
import {
  getLibraryQuestionCardDetails,
  getLibraryQuestionCardDetailsV2,
} from "Worksheet/modules/WorksheetUtils";
import { useHandleScroll } from "Utils/CustomHooks";
import PaginationLoader from "UIComponents/PaginationLoader";
import withLoader from "UIComponents/GqlWithLoader";
import { TODDLE_LIBRARY } from "Worksheet/modules/WorksheetConstants";

/** relative */
import classes from "./QuestionLibraryFeed.scss";
import QuestionCard from "./QuestionCard";

const QuestionLibraryFeed = props => {
  const {
    libraryData,
    previewQuestionId,
    setPreviewQuestionId,
    isFetchingMoreData,
    loadMoreFeed,
    networkStatus,
    hasNextPage,
    addQuestionToSelection,
    libraryType,
    disableSelection,
    isQueriesV2Enabled,
  } = props;

  const { t } = useI18n(["worksheet"]);
  const scrollContainerRef = useRef({});

  useHandleScroll({
    networkStatus,
    loadMoreFeed,
    hasNextPage,
    getScrollRef: () => scrollContainerRef?.current,
  });
  const isToddleLibrary = libraryType === TODDLE_LIBRARY;

  return (
    <div className={classes.container} ref={scrollContainerRef}>
      {_.map(libraryData, item => {
        const questionResource = isQueriesV2Enabled
          ? isToddleLibrary
            ? _.get(item, "node", {})
            : item
          : _.get(item, "node", {});
        const libraryCardDetails = isQueriesV2Enabled
          ? getLibraryQuestionCardDetailsV2({
              question: questionResource,
              t,
              isToddleLibrary,
            }) //WORKSHEET_RESTRUCTURING:Remove getLibraryQuestionCardDetails once support is added in internal tool and toddle library
          : getLibraryQuestionCardDetails({
              questionResource,
              t,
              isToddleLibrary,
            });

        const questionResourceId = _.get(questionResource, "id", "");
        const questionId = isQueriesV2Enabled
          ? questionResourceId
          : _.get(questionResource, "item.id");

        const isPreviewed = isQueriesV2Enabled
          ? _.isEqual(questionId, previewQuestionId)
          : _.isEqual(questionResourceId, previewQuestionId); //WORKSHEET_RESTRUCTURING:clean up this once support is added in internal tool and toddle library

        return (
          <QuestionCard
            isPreviewed={isPreviewed}
            onClick={setPreviewQuestionId}
            addQuestionToSelection={addQuestionToSelection}
            libraryCardDetails={libraryCardDetails}
            disableSelection={disableSelection}
          />
        );
      })}
      {isFetchingMoreData && <PaginationLoader />}
    </div>
  );
};

QuestionLibraryFeed.propTypes = {
  libraryData: PropTypes.array,
  setPreviewQuestionId: PropTypes.func,
  libraryType: PropTypes.bool,
  isQueriesV2Enabled: PropTypes.bool,
};

export default withLoader(QuestionLibraryFeed);
